import type { ColorKeys } from '../../styles/colors'
import { getColor } from '../../styles/colors'

function Email( { color = 'white' as ColorKeys, title = 'Email' } ) {
  const theColor = getColor( color )

  return (
    <svg 
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ title }</title>
      <path 
        d="M15.9608 1.90998L8.01077 7.87998L0.0607758 1.90998C0.0607758 1.63998 0.160784 1.40998 0.350784 1.20998C0.550784 1.00998 0.780781 0.919983 1.05078 0.919983H14.9708C15.2408 0.919983 15.4708 1.01998 15.6708 1.20998C15.8708 1.40998 15.9608 1.63998 15.9608 1.90998ZM0.0507812 3.69998L8.00078 9.66998L15.9508 3.69998V11.86C15.9508 12.13 15.8508 12.36 15.6608 12.56C15.4608 12.76 15.2308 12.85 14.9608 12.85H1.04077C0.770772 12.85 0.540775 12.75 0.340775 12.56C0.140775 12.36 0.0507812 12.13 0.0507812 11.86V3.69998Z"
        fill={ theColor }
      />
    </svg>
  )
}

export default Email
